export const safeStringify = (value: unknown) => {
  try {
    const stringifiedData = JSON.stringify(value);
    return stringifiedData;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Error while serializing error message';
    return errorMessage;
  }
};
